// import { createContactsData } from '../models/contacts-data.model';
// import { createContactDetails } from '../models/contact-details.model';
// import { createGridLayout, createGridItem } from '../../../store/global/gridlayout';

export const contactGroupStates = {
  contactGroups: [],
  selectedContactGroup: {},
  selectedContactGroupLoading: false,
  contactGroupDetails: [],
};
